import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps } from "vue"

import { computed } from 'vue';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer"
import {ScForm} from "@/models/ScForm";
import SelectRemote from "@/components/business/crud/common/SelectRemote.vue";
import SelectRemoteTable from "./SelectRemoteTable.vue";
import {SelectRemoteFieldType} from "@/components/business/crud/interface/FieldType";
import SelectRemoteMulti from "@/components/business/crud/common/SelectRemoteMulti.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectRemoteForm',
  props: {
    propName: {},
    widget: {},
    info: {}
  },
  setup(__props: any) {

const props = __props;

const data = ScForm.useFormData();

const multiValue = computed({
  get: ()=> {
    return data.value[props.propName]?.list
  },
  set:(value) => {
    if (!data.value[props.propName]?.list) {
      data.value[props.propName] = {}
    }
    data.value[props.propName].list = value;
  }
})


return (_ctx: any,_cache: any) => {
  return (_ctx.info.status === 'edit')
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (_ctx.widget.multi)
          ? (_openBlock(), _createBlock(SelectRemoteMulti, {
              key: 0,
              modelValue: multiValue.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((multiValue).value = $event)),
              title: _ctx.info.title,
              widget: _ctx.widget
            }, null, 8, ["modelValue", "title", "widget"]))
          : (_openBlock(), _createBlock(SelectRemote, {
              key: 1,
              title: _ctx.info.title,
              widget: _ctx.widget,
              modelValue: _unref(data)[_ctx.propName],
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(data)[_ctx.propName]) = $event))
            }, null, 8, ["title", "widget", "modelValue"]))
      ], 64))
    : (_openBlock(), _createBlock(SelectRemoteTable, _mergeProps({
        key: 1,
        data: _unref(data)
      }, _ctx.$props), null, 16, ["data"]))
}
}

})